import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.auth.forgot');
import { OnInit, EventEmitter, Output, ChangeDetectorRef as CDR } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-auth-forgot',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.auth.forgot/view.scss */
:host {
  display: block;
}

.forgot-step {
  animation: stepEnter 0.4s cubic-bezier(0.22, 1, 0.36, 1);
}

@keyframes stepEnter {
  from {
    opacity: 0;
    transform: translateY(12px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
button[type=submit]:active {
  transform: scale(0.98);
}`],
})
export class ComponentAuthForgotComponent implements OnInit {
    @Output() public changeMode = new EventEmitter<string>();

    public step: number = 1;

    public data: any = {
        id: '',
        email: '',
        password: '',
        password_confirm: ''
    };

    constructor(@Inject( Service)         public service: Service,@Inject( CDR    )         public ref: CDR    ) { }

    public async ngOnInit() {
        // await this.service.init();
        await this.service.render();
    }

    public async verify() {
        const alert = async (msg: string) => await this.service.alert.show({ message: msg, status: 'error', action: '확인', cancel: false });
        if (!this.data.id || !this.data.email) {
            return await alert('아이디와 이메일을 입력해주세요.');
        }

        try {
            const { code, data } = await wiz.call('verify', { id: this.data.id, email: this.data.email });
            if (code !== 200) {
                return await alert(data);
            }
            
            this.step = 2;
            await this.service.render();
        } catch (e) {
            await alert('확인 중 오류가 발생했습니다.');
        }
    }

    public async reset() {
        const alert = async (msg: string) => await this.service.alert.show({ message: msg, status: 'error', action: '확인', cancel: false });
        if (!this.data.password || !this.data.password_confirm) {
            return await alert('비밀번호를 입력해주세요.');
        }

        if (this.data.password !== this.data.password_confirm) {
            return await alert('비밀번호가 일치하지 않습니다.');
        }

        if (this.data.password.length < 4) {
            return await alert('비밀번호는 최소 4자 이상이어야 합니다.');
        }
        
        try {
            let user = JSON.parse(JSON.stringify(this.data));
            user.password = this.service.auth.hash(user.password);

            const { code, data } = await wiz.call('reset', user);
            if (code !== 200) {
                return await alert(data);
            }

            await this.service.alert.show({
                title: '성공',
                message: '비밀번호가 성공적으로 변경되었습니다. 다시 로그인해주세요.',
                status: 'success',
                action: '확인',
                cancel: false
            });
            location.reload();
        } catch (e) {
            await alert('비밀번호 변경 중 오류가 발생했습니다.');
        }
    }

    public gotoLogin() {
        this.changeMode.emit('login');
    }
}

export default ComponentAuthForgotComponent;